import React from "react";

interface NewStateIconProps {
  className?: string;
  width?: number;
  height?: number;
  fill?: string;
  fillOpacity?: string | number;
}

const NewStateIcon: React.FC<NewStateIconProps> = ({
  className = "",
  width = 16,
  height = 16,
  fill = "#E0E0E0",
  fillOpacity,
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M11.9997 8.66683H8.66634V12.0002C8.66634 12.3668 8.36634 12.6668 7.99967 12.6668C7.63301 12.6668 7.33301 12.3668 7.33301 12.0002V8.66683H3.99967C3.63301 8.66683 3.33301 8.36683 3.33301 8.00016C3.33301 7.6335 3.63301 7.3335 3.99967 7.3335H7.33301V4.00016C7.33301 3.6335 7.63301 3.3335 7.99967 3.3335C8.36634 3.3335 8.66634 3.6335 8.66634 4.00016V7.3335H11.9997C12.3663 7.3335 12.6663 7.6335 12.6663 8.00016C12.6663 8.36683 12.3663 8.66683 11.9997 8.66683Z"
        fill={fill}
        fillOpacity={fillOpacity}
      />
    </svg>
  );
};

export default NewStateIcon;
